/* global $: false */
'use strict';

$( document ).ready(function() {
	'use strict';

	/**
	 * Webhotelier Form
	 */
	let $webhotelierForm = $('#webhotelier-form');
	if ($webhotelierForm.length > 0) {
		let elWebhotelierForm = $webhotelierForm;
		elWebhotelierForm.webhotelierForm(elWebhotelierForm.data('json'));
	}
});

/**
 * Webhotelier Form Function
 *
 * @param options
 */
$.fn.webhotelierForm = function(options) {
	let el = $(this);

	let settings = $.extend({
		// 'split_dates': $(this).data('split_dates'),
		// 'icon_dates': $(this).data('icon_date'),
	}, options);

	let checkinDateSplit = el.find('#checkin-date-split');

	function getField(id) {
		let el = $('#' + id + '-picker');
		return el.length ? el : null;
	}

	function fillSplitDates(id) {
		let el = getField(id);
		if (el !== null) {
			let date = el.datepicker('getDate');
			el.parent().find('.day').text(date.getDate());
			el.parent().find('.month').text(date.getMonth());
			el.parent().find('.year').text(date.getFullYear());
		}
	}

	function pickerSetup(id, date) {
		let el = getField(id);

		if (el !== null) {
			let checkin = (id === 'checkin');

			el.datepicker({
				altField: el.get(0).form[id],
				altFormat: 'yy-mm-dd',
				dateFormat: 'd/m/yy',
				onSelect: function () {
					if (checkin && getField('checkout') !== null) {
						let constraint = new Date(el.datepicker('getDate'));
						constraint.setDate(constraint.getDate() + 1);
						getField('checkout').datepicker('option', 'minDate', constraint);
					}
					if ( settings.split_dates ) {
						fillSplitDates(id);
					}
				},
				numberOfMonths: 2,
				mandatory: true,
				firstDay: 1,
				minDate: checkin ? 0 : 1,
				maxDate: '+2y',
				showOn: settings.icon_date ? 'button' : 'focus',
				buttonImage: settings.icon_date ? settings.icon_date : '',
				buttonImageOnly: settings.icon_date ? 'true' : 'false',
				buttonText: 'Select date'
			});
			el.datepicker('setDate', date);

			if ( checkinDateSplit.length > 0 ) {
				fillSplitDates(id);
			}
		}
	}

	pickerSetup('checkin', '+0');
	pickerSetup('checkout', '+1');

	$('#checkin-date-split, #checkout-date-split').on('click', function() {
		$( this ).parent().find('input').datepicker( 'show' );
	});

};
